import { inject, Injectable} from '@angular/core';
import { SignHistoryService } from './sign-history.service';
import { BinderService } from '../api/binder.service';
import { MessageService } from 'primeng/api';
import { Binder, BinderSmall } from '@/models/binder.model';

@Injectable({
  providedIn: 'root'
})

export class BinderLockService {
    signHistoryService = inject(SignHistoryService);
    binderService = inject(BinderService);
    messageService = inject(MessageService);

    handleSignUnlock(binderId: number) {
        const binder = this.binderService.currentBinder();
        if(binder && binder.ES_Hash && binder.ES_Hash !== '') {
            this.cancelSignatureRequest(binder.BinderID);
        }

        else {
            this.updateBinder({ProjectStatus: 3, ES_Hash: null});
            this.messageService.add({severity:'success', summary: 'Binder Unlocked', detail: 'Binder unlocked'});
        }
        
    }

    cancelSignatureRequest(binderId: number) {
        this.signHistoryService.cancelSignatureRequest(binderId);
    }

    updateBinder(binderData:Partial<BinderSmall>) {
        const binderId = this.binderService.currentBinder().BinderID
        console.log('patching');
        this.binderService.updateBinder(binderId, binderData).subscribe({
          next: (updatedBinder: Binder) => {
            this.binderService.patchBinder(updatedBinder);
          },
          error: (error) => {
            console.error('Error updating binder:', error);
          }
        }
        );
    
      }

}